import React, { Component } from 'react';
import PropTypes from "prop-types";
import Config from "../../../../config/main";
import { connect } from "react-redux";
import {ClosePopup} from "../../../../actions/ui";
import {RemoveStackerBalance} from "../../../../actions/terminal";
import CountDownComponent from "../../countDownClock";
import {t} from "../../../../../dev/helpers/translator";

class StackerBalanceItem extends Component {
    constructor (props) {
        super(props);
        this.closeNotification = this.closeNotification.bind(this);
        this.printBalance = this.printBalance.bind(this);
    }
    printBalance () {
        return () => {
            this.props.dispatch(RemoveStackerBalance(null));
            this.props.dispatch(ClosePopup("showStackerBalance"));
        };
    }
    closeNotification () {
        return () => this.props.dispatch(ClosePopup("showStackerBalance"));
    }
    render () {
        let currency = JSON.parse(sessionStorage.getItem("authData")).currency,
            { data } = this.props,
            symbol = Config.main.currency[currency],
            stackerBalanceText = t(`Cash amount in stacker: ${symbol}`);
        return <div className="ticket-results-view-p">
            <CountDownComponent second={10}/>
            {
                <h3 className="hopper-info" dangerouslySetInnerHTML={{ __html: `${stackerBalanceText} ${data}` }}></h3>
            }
            <div className="buttons-view-w-t">
                <ul>
                    <li>
                        <div className="separator-box-buttons-m">
                            <button className="button-view-normal-m" onClick={this.printBalance()}>
                                {t("Print")}
                            </button>
                        </div>
                    </li>
                    <li>
                        <div className="separator-box-buttons-m">
                            <button className="button-view-normal-m" onClick={this.closeNotification()}>
                                Ok
                            </button>
                        </div>
                    </li>
                </ul>
            </div>
        </div>;
    }

}

StackerBalanceItem.propsTypes = {
    data: PropTypes.string,
    currency: PropTypes.string
};

const mapStateToProps = (state) => {
    return {
        currency: state.user.currency
    };
};

export default connect(mapStateToProps)(StackerBalanceItem);